// Australia

// import australia1 from '../images/contrywisecards/'


// Bali
import bali1 from '../images/contrywisecards/Bali.png'

//  Dubai
import dubai1 from '../images/contrywisecards/Dubai/1.png'
import dubai2 from '../images/contrywisecards/Dubai/2.png'

// Europe
import europe1 from '../images/contrywisecards/Europe/1.png'
import europe2 from '../images/contrywisecards/Europe/3.png'
import europe3 from '../images/contrywisecards/Europe/3.png'

// Hong Kong
import hongKong1 from '../images/contrywisecards/Hongkong/1.png'
import hongKong2 from '../images/contrywisecards/Hongkong/2.png'


// Malaysia
import malaysia1 from '../images/contrywisecards/Malaysis/1.png'
import malaysia2 from '../images/contrywisecards/Malaysis/2.png'
import malaysia3 from '../images/contrywisecards/Malaysis/3.png'
import malaysia4 from '../images/contrywisecards/Malaysis/4.png'
import malaysia5 from '../images/contrywisecards/Malaysis/5.png'
import malaysia6 from '../images/contrywisecards/Malaysis/6.png'


// Maldives
import maldives1 from '../images/contrywisecards/Maldives/1.png'
import maldives2 from '../images/contrywisecards/Maldives/2.png'
import maldives3 from '../images/contrywisecards/Maldives/3.png'


// Mauritius
import mauritius1 from '../images/contrywisecards//mauritius/1.png'
import mauritius2 from '../images/contrywisecards//mauritius/2.png'
import mauritius3 from '../images/contrywisecards//mauritius/3.png'


// New Zealand
import newZealand1 from '../images/contrywisecards/Newzealand/1.png'
import newZealand2 from '../images/contrywisecards/Newzealand/2.png'
import newZealand3 from '../images/contrywisecards/Newzealand/3.png'
import newZealand4 from '../images/contrywisecards/Newzealand/4.png'


// Seychelles
import seychelles1 from '../images/contrywisecards/Seychelles/1.png'
import seychelles2 from '../images/contrywisecards/Seychelles/2.png'
import seychelles3 from '../images/contrywisecards/Seychelles/3.png'


// Singapore
import singapore1 from '../images/contrywisecards/Singapore/1.png'
import singapore2 from '../images/contrywisecards/Singapore/2.png'
import singapore3 from '../images/contrywisecards/Singapore/3.png'
import singapore4 from '../images/contrywisecards/Singapore/4.png'
import singapore5 from '../images/contrywisecards/Singapore/5.png'
import singapore6 from '../images/contrywisecards/Singapore/6.png'


// South Africa
import southAfrica1 from '../images/contrywisecards/South Africa/1.png'
import southAfrica2 from '../images/contrywisecards/South Africa/2.png'
import southAfrica3 from '../images/contrywisecards/South Africa/3.png'


// Sri Lanka
import sriLanka1 from '../images/contrywisecards/Sri lanka/1.png'
import sriLanka2 from '../images/contrywisecards/Sri lanka/2.png'
import sriLanka3 from '../images/contrywisecards/Sri lanka/3.png'


// Switzerland
// import switzerland1 from '../images/contrywisecards/Switzerland.png'


// Thailand
import thailand1 from '../images/contrywisecards/Thailand/1.png'
import thailand2 from '../images/contrywisecards/Thailand/2.png'
import thailand3 from '../images/contrywisecards/Thailand/3.png'
import thailand4 from '../images/contrywisecards/Thailand/4.png'
import thailand5 from '../images/contrywisecards/Thailand/5.png'
import thailand6 from '../images/contrywisecards/Thailand/6.png'


// Turkey
import turkey1 from '../images/contrywisecards/Turkey/1.png'
import turkey2 from '../images/contrywisecards/Turkey/2.png'
import turkey3 from '../images/contrywisecards/Turkey/3.png'


// Singapore + Bali
import singaporeBali1 from '../images/contrywisecards/Singapore+Bali/1.png'
import singaporeBali2 from '../images/contrywisecards/Singapore+Bali/2.png'
import singaporeBali3 from '../images/contrywisecards/Singapore+Bali/3.png'
import singaporeBali4 from '../images/contrywisecards/Singapore+Bali/4.png'
import singaporeBali5 from '../images/contrywisecards/Singapore+Bali/5.png'
import singaporeBali6 from '../images/contrywisecards/Singapore+Bali/6.png'
import singaporeBali7 from '../images/contrywisecards/Singapore+Bali/7.png'


// Singapore + Malaysia
import singaporeMalaysia1 from '../images/contrywisecards/Singapore + Malaysia/1.png'
import singaporeMalaysia2 from '../images/contrywisecards/Singapore + Malaysia/2.png'
import singaporeMalaysia3 from '../images/contrywisecards/Singapore + Malaysia/3.png'
import singaporeMalaysia4 from '../images/contrywisecards/Singapore + Malaysia/4.png'
import singaporeMalaysia5 from '../images/contrywisecards/Singapore + Malaysia/5.png'
import singaporeMalaysia6 from '../images/contrywisecards/Singapore + Malaysia/6.png'
// import singaporeMalaysia7 from '../images/contrywisecards/Singapore + Malaysia/7.png'
// import singaporeMalaysia8 from '../images/contrywisecards/Singapore + Malaysia/8.png'
// import singaporeMalaysia9 from '../images/contrywisecards/Singapore + Malaysia/9.png'
// import singaporeMalaysia10 from '../images/contrywisecards/Singapore + Malaysia/10.png'
// import singaporeMalaysia11 from '../images/contrywisecards/Singapore + Malaysia/11.png'


// Others international
import othersInternational1 from '../images/contrywisecards/Other Internation/1.png'
import othersInternational2 from '../images/contrywisecards/Other Internation/2.png'
import othersInternational3 from '../images/contrywisecards/Other Internation/3.png'
import othersInternational4 from '../images/contrywisecards/Other Internation/4.png'
import othersInternational5 from '../images/contrywisecards/Other Internation/5.png'
import othersInternational6 from '../images/contrywisecards/Other Internation/6.png'


// Bhutan
import bhutan1 from '../images/contrywisecards/Bhutan/1.png'
import bhutan2 from '../images/contrywisecards/Bhutan/2.png'
import bhutan3 from '../images/contrywisecards/Bhutan/3.png'


// Africa
import africa1 from '../images/contrywisecards/Africa/1.png'
import africa2 from '../images/contrywisecards/Africa/2.png'
import africa3 from '../images/contrywisecards/Africa/3.png'


// Egypt
import egypt1 from '../images/contrywisecards/egypt/1.png'
import egypt2 from '../images/contrywisecards/egypt/2.png'


// Cambodia
import cambodia1 from '../images/contrywisecards/Combodia/1.png'
import cambodia2 from '../images/contrywisecards/Combodia/2.png'
import cambodia3 from '../images/contrywisecards/Combodia/3.png'
import cambodia4 from '../images/contrywisecards/Combodia/4.png'


// Vietnam
import vietnam1 from '../images/contrywisecards/Vietnam/1.png'
import vietnam2 from '../images/contrywisecards/Vietnam/2.png'
import vietnam3 from '../images/contrywisecards/Vietnam/3.png'
import vietnam4 from '../images/contrywisecards/Vietnam/4.png'
import vietnam5 from '../images/contrywisecards/Vietnam/5.png'
import vietnam6 from '../images/contrywisecards/Vietnam/6.png'
import vietnam7 from '../images/contrywisecards/Vietnam/7.png'


// Nepal
import nepal1 from '../images/contrywisecards/Nepal/1.png'
import nepal2 from '../images/contrywisecards/Nepal/2.png'
import nepal3 from '../images/contrywisecards/Nepal/3.png'

// CIS Countries


// Iceland
import iceland1 from '../images/contrywisecards/Iceland/1.png'
import iceland2 from '../images/contrywisecards/Iceland/2.png'


// Kenya
import kenya1 from '../images/contrywisecards/Kenya/1.png'
import kenya2 from '../images/contrywisecards/Kenya/2.png'


// Azerbaijan
import azerbaijan1 from '../images/contrywisecards/Azerbaijan/1.png'
import azerbaijan2 from '../images/contrywisecards/Azerbaijan/2.png'
import azerbaijan3 from '../images/contrywisecards/Azerbaijan/3.png'


// UAE
// import UAE1 from '../images/contrywisecards/UAE.png'


// China
// import china1 from '../images/contrywisecards/China.png'


// Japan
import japan1 from '../images/contrywisecards/Japan/1.png'
import japan2 from '../images/contrywisecards/Japan/2.png'
import japan3 from '../images/contrywisecards/Japan/3.png'


// Canada
import canada1 from '../images/contrywisecards/Canda/1.png'
import canada2 from '../images/contrywisecards/Canda/2.png'
import canada3 from '../images/contrywisecards/Canda/3.png'
import canada4 from '../images/contrywisecards/Canda/4.png'
import canada5 from '../images/contrywisecards/Canda/5.png'
import canada6 from '../images/contrywisecards/Canda/6.png'
import canada7 from '../images/contrywisecards/Canda/7.png'
// import canada8 from '../images/contrywisecards/Canda/8.png'
// import canada9 from '../images/contrywisecards/Canda/9.png'
// import canada10 from '../images/contrywisecards/Canda/10.png'


// Israel
import israel1 from '../images/contrywisecards/Israel/1.png'
// import israel2 from '../images/contrywisecards/Israel/2.png'


// USA
import usa1 from '../images/contrywisecards/USA/1.png'
import usa2 from '../images/contrywisecards/USA/2.png'
import usa3 from '../images/contrywisecards/USA/3.png'
import usa4 from '../images/contrywisecards/USA/4.png'
import usa5 from '../images/contrywisecards/USA/5.png'
import usa6 from '../images/contrywisecards/USA/6.png'
import usa7 from '../images/contrywisecards/USA/7.png'


// Russia
import russia1 from '../images/contrywisecards/Russia/1.png'
import russia2 from '../images/contrywisecards/Russia/2.png'

// Myanmar


// Jordan
import jordan1 from '../images/contrywisecards/Jorden/1.png'
// import jordan2 from '../images/contrywisecards/Jorden/2.png'


// Uzbekistan
import uzbekistan1 from '../images/contrywisecards/Uzbekistan/1.png'
import uzbekistan2 from '../images/contrywisecards/Uzbekistan/2.png'


export const CountryWiseCards = [

    // Australia
    {
        countryName: 'Australia',
        tourName: '12N Stunning Australia',
        tourImg: '',
        tourPrice: '1,20,000',
        days: '13',
        night: '12',
        pdfLink: ''
    },

    // Bali

    {
        countryName: 'Bali',
        tourName: '5 Star | Deluxe Room | Nusa Dua Beach Resort, Bali',
        tourImg: bali1,
        tourPrice: '8,520',
        days: '0',
        night: '1',
        pdfLink: ''
    },

    // Dubai

    {
        countryName: 'Dubai',
        tourName: 'Dubai Visa-Single Entry',
        tourImg: dubai1,
        tourPrice: '5,870',
        days: '0',
        night: '0',
        pdfLink: ''
    },
    // best1
    {
        countryName: 'Dubai',
        tourName: 'Discover Dubai with Theme Parks',
        tourImg: dubai2,
        tourPrice: '25,999',
        days: '5',
        night: '4',
        pdfLink: ''
    },

    //  Europe
    {
        countryName: 'Europe',
        tourName: 'Europe (Schengen) Sticker Visa',
        tourImg: europe1,
        tourPrice: '8,650',
        days: '0',
        night: '0',
        pdfLink: ''
    },
    {
        countryName: 'Europe',
        tourName: 'Swiss to Venice (Fixed Departure)',
        tourImg: europe2,
        tourPrice: '76,999 ',
        days: '0',
        night: '0',
        pdfLink: ''
    },
    {
        countryName: 'Europe',
        tourName: '7N Europe - Idyllic Iceland',
        tourImg: europe3,
        tourPrice: '2,17,150',
        days: '0',
        night: '0',
        pdfLink: ''
    },

    // Hong Kong
    // best2
    {
        countryName: 'Hong Kong',
        tourName: 'Amazing 4N Hong Kong and 2N Macau',
        tourImg: hongKong1,
        tourPrice: '57,500',
        days: '5',
        night: '4',
        pdfLink: ''
    },
    {
        countryName: 'Hong Kong',
        tourName: '4N Spectacular Hong Kong with Disneyland',
        tourImg: hongKong2,
        tourPrice: '38,000 ',
        days: '5',
        night: '4',
        pdfLink: ''
    },


    // Malaysia
    {
        countryName: 'Malaysia',
        tourName: 'Hotel Stay: Berjaya Times Square – Kuala Lumpur, Malaysia',
        tourImg: malaysia1,
        tourPrice: '3,450 ',
        days: '0',
        night: '1',
        pdfLink: ''
    },
    {
        countryName: 'Malaysia',
        tourName: 'Get Malaysia Entri',
        tourImg: malaysia2,
        tourPrice: '1,670',
        days: '0',
        night: '0',
        pdfLink: ''
    },
    // best3
    {
        countryName: 'Malaysia',
        tourName: 'Singapore and Malaysia',
        tourImg: malaysia3,
        tourPrice: '29,888 ',
        days: '5',
        night: '4',
        pdfLink: ''
    },
    {
        countryName: 'Malaysia',
        tourName: 'Malaysia - Ipoh and Kuala Lumpur',
        tourImg: malaysia4,
        tourPrice: '25,000',
        days: '5',
        night: '4',
        pdfLink: ''
    },
    {
        countryName: 'Malaysia',
        tourName: 'Malaysia - Kuala Lumpur with Langkawi',
        tourImg: malaysia5,
        tourPrice: '16,500 ',
        days: '6',
        night: '5',
        pdfLink: ''
    },
    {
        countryName: 'Malaysia',
        tourName: '4 Star | Superior Room | Novotel Kuala Lumpur City Centre',
        tourImg: malaysia6,
        tourPrice: '7,300 ',
        days: '0',
        night: '1',
        pdfLink: ''
    },


    // Maldives
    // best4
    {
        countryName: 'Maldives',
        tourName: '3N Maldives - Bandos',
        tourImg:maldives1,
        tourPrice: '60,800',
        days: '4',
        night: '3',
        pdfLink: ''
    },
    {
        countryName: 'Maldives',
        tourName: '3N Maldives - Fun Island Resort',
        tourImg:maldives2,
        tourPrice: '57,500',
        days: '4',
        night: '3',
        pdfLink: ''
    },
    {
        countryName: 'Maldives',
        tourName: '3N Maldives - Fushifaru Maldives',
        tourImg:maldives3,
        tourPrice: '1,15,999',
        days: '4',
        night: '3',
        pdfLink: ''
    },

    // Mauritius
    {
        countryName: 'Mauritius',
        tourName: 'Mauritius - Le Grand Bleu (3 Star)',
        tourImg: mauritius1,
        tourPrice: '25,999',
        days: '7',
        night: '6',
        pdfLink: ''
    },
    {
        countryName: 'Mauritius',
        tourName: ' Lagoon Attitude (4 Star)',
        tourImg: mauritius2,
        tourPrice: '37,999',
        days: '7',
        night: '6',
        pdfLink: ''
    },
    {
        countryName: 'Mauritius',
        tourName: ' Mauritius - Anelia Hotel (4 Star)',
        tourImg: mauritius3,
        tourPrice: 'USD 440',
        days: '7',
        night: '6',
        pdfLink: ''
    },

    // New Zealand

    {
        countryName: 'New Zealand',
        tourName: 'ITC Grand Bharat',
        tourImg:newZealand1,
        tourPrice: '14,298',
        days: '0',
        night: '0',
        pdfLink: ''
    },
    {
        countryName: 'New Zealand',
        tourName: 'New Zealand Visa',
        tourImg:newZealand2,
        tourPrice: '11,500',
        days: '0',
        night: '0',
        pdfLink: ''
    },
    {
        countryName: 'New Zealand',
        tourName: 'Untouched South New Zealand',
        tourImg:newZealand3,
        tourPrice: '1,50,000',
        days: '8',
        night: '7',
        pdfLink: ''
    },
    {
        countryName: 'New Zealand',
        tourName: 'Scenic South Island in Newzealand',
        tourImg:newZealand4,
        tourPrice: '95,000',
        days: '8',
        night: '7',
        pdfLink: ''
    },

    // Seychelles
    {
        countryName: 'Seychelles',
        tourName: 'Seychelles Honeymoon Package',
        tourImg: seychelles1,
        tourPrice: '71,670',
        days: '6',
        night: '5',
        pdfLink: ''
    },
    {
        countryName: 'Seychelles',
        tourName: 'Ferry: Mahe to La Digue',
        tourImg: seychelles2,
        tourPrice: '5,550',
        days: '0',
        night: '0',
        pdfLink: ''
    },
    {
        countryName: 'Seychelles',
        tourName: 'Picturesque Seychelles',
        tourImg: seychelles3,
        tourPrice: '53,500',
        days: '4',
        night: '3',
        pdfLink: ''
    },

    // Singapore

    {
        countryName: 'Singapore',
        tourName: 'Singapore Flyer Ticket and Dinner',
        tourImg:singapore1,
        tourPrice: '7,500',
        days: '0',
        night: '1',
        pdfLink: ''
    },
    {
        countryName: 'Singapore',
        tourName: 'Singapore Visa-Single Entry',
        tourImg:singapore2,
        tourPrice: '3,000',
        days: '0',
        night: '0',
        pdfLink: ''
    },
    {
        countryName: 'Singapore',
        tourName: 'Singapore and Malaysia',
        tourImg:singapore3,
        tourPrice: '29,888',
        days: '6',
        night: '5',
        pdfLink: ''
    },
    // best5
    {
        countryName: 'Singapore',
        tourName: ' Singapore',
        tourImg:singapore4,
        tourPrice: '28,999',
        days: '5',
        night: '4',
        pdfLink: ''
    },
    {
        countryName: 'Singapore',
        tourName: 'Magical Singapore',
        tourImg:singapore5,
        tourPrice: '24,500',
        days: '5',
        night: '4',
        pdfLink: ''
    },
    {
        countryName: 'Singapore',
        tourName: 'Singapore with Sightseeing',
        tourImg:singapore6,
        tourPrice: '24,500',
        days: '0',
        night: '0',
        pdfLink: ''
    },


    // South Africa
    {
        countryName: 'South Africa',
        tourName: 'South Africa Delight',
        tourImg:southAfrica1,
        tourPrice: '1,73,999',
        days: '9',
        night: '8',
        pdfLink: ''
    },
    {
        countryName: 'South Africa',
        tourName: 'Kenya-Nairobi,Lake Nakuru National Park Heaven of Flamingo',
        tourImg:southAfrica2,
        tourPrice: '61,250',
        days: '5',
        night: '4',
        pdfLink: ''
    },
    // best6
    {
        countryName: 'South Africa',
        tourName: '6N Kenya-Glimpse Of Mt. Kilimanjaro',
        tourImg:southAfrica3,
        tourPrice: '79,400',
        days: '7',
        night: '6',
        pdfLink: ''
    },

    // Sri Lanka
    {
        countryName: 'Sri Lanka',
        tourName: 'Sri Lanka Visa',
        tourImg:sriLanka1,
        tourPrice: '200',
        days: '0',
        night: '0',
        pdfLink: ''
    },
    {
        countryName: 'Sri Lanka',
        tourName: 'Sri Lanka - Kandy, Bentota and Colombo',
        tourImg:sriLanka2,
        tourPrice: '18,799',
        days: '5',
        night: '4',
        pdfLink: ''
    },
    {
        countryName: 'Sri Lanka',
        tourName: 'Sri Lanka - Kandy, Bentota and Colombo',
        tourImg: sriLanka3,
        tourPrice: 'USD 285',
        days: '7',
        night: '6',
        pdfLink: ''
    },

    // Switzerland

    // Thailand
    {
        countryName: 'Thailand',
        tourName: 'Arrival Transfer: Suvarnabhumi International Airport to accommodation',
        tourImg: thailand1,
        tourPrice: '3,450',
        days: '0',
        night: '0',
        pdfLink: ''
    },
    {
        countryName: 'Thailand',
        tourName: 'Thailand e-Visa - 15 days',
        tourImg: thailand2,
        tourPrice: '2,880',
        days: '0',
        night: '0',
        pdfLink: ''
    },
    // best7
    {
        countryName: 'Thailand',
        tourName: 'Full Day Trip from Phuket to Phi Phi Island by Big Boat with Lunch',
        tourImg: thailand3,
        tourPrice: '6,350',
        days: '0',
        night: '1',
        pdfLink: ''
    },
    {
        countryName: 'Thailand',
        tourName: 'Best of Phuket and Krabi',
        tourImg: thailand4,
        tourPrice: '16,999',
        days: '5',
        night: '0',
        pdfLink: ''
    },
    {
        countryName: 'Thailand',
        tourName: 'Bangkok and Pattaya - land only package',
        tourImg: thailand5,
        tourPrice: '4,500',
        days: '5',
        night: '0',
        pdfLink: ''
    },
    {
        countryName: 'Thailand',
        tourName: '4 Nights Thailand with Phuket & Krabi',
        tourImg: thailand6,
        tourPrice: '16,000',
        days: '5',
        night: '4',
        pdfLink: ''
    },

    // Turkey
    {
        countryName: 'Turkey',
        tourName: 'Istanbul, Kusadasi, Pamukkale and Antalya',
        tourImg: turkey1,
        tourPrice: '77,130',
        days: '9',
        night: '8',
        pdfLink: ''
    },
    {
        countryName: 'Turkey',
        tourName: 'Istanbul, Antalya & Cappadocia',
        tourImg: turkey2,
        tourPrice: '63,800',
        days: '7',
        night: '6',
        pdfLink: ''
    },
    {
        countryName: 'Turkey',
        tourName: 'Istanbul with City Tour & Bosphorus Cruise',
        tourImg: turkey3,
        tourPrice: '22,000',
        days: '4',
        night: '3',
        pdfLink: ''
    },

    // Singapore + Bali
    {
        countryName: 'Singapore + Bali',
        tourName: 'Singapore Flyer Ticket and Dinner',
        tourImg:singaporeBali1,
        tourPrice: '7,500',
        days: '0',
        night: '1',
        pdfLink: ''
    },
    {
        countryName: 'Singapore + Bali',
        tourName: 'Singapore Visa-Single Entry',
        tourImg:singaporeBali2,
        tourPrice: '3,000',
        days: '0',
        night: '0',
        pdfLink: ''
    },
    {
        countryName: 'Singapore + Bali',
        tourName: 'Singapore and Malaysia',
        tourImg:singaporeBali3,
        tourPrice: '29,888',
        days: '6',
        night: '5',
        pdfLink: ''
    },
    {
        countryName: 'Singapore + Bali',
        tourName: 'Deluxe Room | Nusa Dua Beach Resort, Bali',
        tourImg:singaporeBali4,
        tourPrice: '8,520',
        days: '0',
        night: '1',
        pdfLink: ''
    },
    {
        countryName: 'Singapore + Bali',
        tourName: '4 Nights / 5 Days Singapore',
        tourImg:singaporeBali5,
        tourPrice: '28,999',
        days: '5',
        night: '4',
        pdfLink: ''
    },
    {
        countryName: 'Singapore + Bali',
        tourName: ' Magical Singapore',
        tourImg:singaporeBali6,
        tourPrice: '24,500',
        days: '4',
        night: '3',
        pdfLink: ''
    },
    {
        countryName: 'Singapore + Bali',
        tourName: 'Singapore with Sightseeing',
        tourImg:singaporeBali7,
        tourPrice: '24,500',
        days: '4',
        night: '3',
        pdfLink: ''
    },

    // Singapore + Malaysia
    {
        countryName: 'Singapore + Malaysia',
        tourName: 'Singapore Flyer Ticket and Dinner',
        tourImg:singaporeMalaysia1,
        tourPrice: '7,500',
        days: '0',
        night: '1',
        pdfLink: ''
    },
    {
        countryName: 'Singapore + Malaysia',
        tourName: 'Hotel Stay: Berjaya Times Square – Kuala Lumpur, Malaysia',
        tourImg:singaporeMalaysia2,
        tourPrice: '3,450',
        days: '0',
        night: '1',
        pdfLink: ''
    },
    {
        countryName: 'Singapore + Malaysia',
        tourName: 'Get Malaysia Entri',
        tourImg:singaporeMalaysia3,
        tourPrice: '1,670',
        days: '0',
        night: '0',
        pdfLink: ''
    },
    {
        countryName: 'Singapore + Malaysia',
        tourName: 'Malaysia - Ipoh and Kuala Lumpur',
        tourImg: singaporeMalaysia4,
        tourPrice: '25,000',
        days: '5',
        night: '4',
        pdfLink: ''
    },
    {
        countryName: 'Singapore + Malaysia',
        tourName: 'Malaysia - Kuala Lumpur with Langkawi',
        tourImg:singaporeMalaysia5,
        tourPrice: '16,500',
        days: '6',
        night: '5',
        pdfLink: ''
    },
    {
        countryName: 'Singapore + Malaysia',
        tourName: '4 Star | Superior Room | Novotel Kuala Lumpur City Centre',
        tourImg:singaporeMalaysia6,
        tourPrice: '7,300',
        days: '0',
        night: '1',
        pdfLink: ''
    },

    // Others international
    // best8
    {
        countryName: 'Others international',
        tourName: '3N Beautiful Bangladesh',
        tourImg:othersInternational1,
        tourPrice: '50,600',
        days: '4',
        night: '3',
        pdfLink: ''
    },
    {
        countryName: 'Others international',
        tourName: '6Nights Philippines - Cebu, Bohol & Manila',
        tourImg:othersInternational2,
        tourPrice: '17,400',
        days: '7',
        night: '6',
        pdfLink: ''
    },
    {
        countryName: 'Others international',
        tourName: 'Pachmarhi Hill Station',
        tourImg:othersInternational3,
        tourPrice: '5,200',
        days: '3',
        night: '2',
        pdfLink: ''
    },
    {
        countryName: 'Others international',
        tourName: 'Madhya Pradesh Wildlife - Panna, Bandhavgarh and Kanha',
        tourImg:othersInternational4,
        tourPrice: '9,200',
        days: '7',
        night: '6',
        pdfLink: ''
    },
    {
        countryName: 'Others international',
        tourName: 'Canada Sticker Visa',
        tourImg:othersInternational5,
        tourPrice: '13,500',
        days: '0',
        night: '0',
        pdfLink: ''
    },
    {
        countryName: 'Others international',
        tourName: 'Pondicherry',
        tourImg:othersInternational6,
        tourPrice: '9,800',
        days: '0',
        night: '0',
        pdfLink: ''
    },

    // Bhutan
    // best9
    {
        countryName: 'Bhutan',
        tourName: 'Bhutan with Phuentsholing, Thimphu & Paro',
        tourImg: bhutan1,
        tourPrice: '25,999',
        days: '6',
        night: '5',
        pdfLink: ''
    },
    {
        countryName: 'Bhutan',
        tourName: '4N Amazing Bhutan',
        tourImg: bhutan2,
        tourPrice: '22,000',
        days: '5',
        night: '4',
        pdfLink: ''
    },
    {
        countryName: 'Bhutan',
        tourName: 'BEST OF BHUTAN',
        tourImg: bhutan3,
        tourPrice: '25,000',
        days: '7',
        night: '6',
        pdfLink: ''
    },

    // Africa
    // best10
    {
        countryName: 'Africa',
        tourName: 'South Africa Delight',
        tourImg:africa1,
        tourPrice: '1,73,999',
        days: '9',
        night: '8',
        pdfLink: ''
    },
    {
        countryName: 'Africa',
        tourName: 'Kenya-Nairobi,Lake Nakuru National Park Heaven of Flamingo',
        tourImg:africa2,
        tourPrice: '61,250',
        days: '5',
        night: '4',
        pdfLink: ''
    },
    {
        countryName: 'Africa',
        tourName: '6N Kenya-Glimpse Of Mt. Kilimanjaro',
        tourImg:africa3,
        tourPrice: '79,400',
        days: '7',
        night: '6',
        pdfLink: ''
    },


    // Egypt
    {
        countryName: 'Egypt',
        tourName: 'Egypt (3N CAIRO, 4N CRUISE)',
        tourImg: egypt1,
        tourPrice: '65,150',
        days: '8',
        night: '7',
        pdfLink: ''
    },
    {
        countryName: 'Egypt',
        tourName: 'Egypt',
        tourImg: egypt2,
        tourPrice: '28,750',
        days: '5',
        night: '4',
        pdfLink: ''
    },

    // Cambodia
    {
        countryName: 'Cambodia',
        tourName: ' PHNOM PENH – SIEM REAP',
        tourImg: cambodia1,
        tourPrice: '26,350',
        days: '5',
        night: '4',
        pdfLink: ''
    },
    {
        countryName: 'Cambodia',
        tourName: 'Siem Reap',
        tourImg: cambodia2,
        tourPrice: '20,850',
        days: '4',
        night: '3',
        pdfLink: ''
    },
    {
        countryName: 'Cambodia',
        tourName: 'Siem Reap – Pheah Vihear',
        tourImg: cambodia3,
        tourPrice: '42,750',
        days: '7',
        night: '6',
        pdfLink: ''
    },
    {
        countryName: 'Cambodia',
        tourName: 'PHNOM PENH – SIHNAOUKVILE - SIEM REAP',
        tourImg: cambodia4,
        tourPrice: '36,400',
        days: '6',
        night: '5',
        pdfLink: ''
    },

    // Vietnam
    {
        countryName: 'Vietnam',
        tourName: '7-Day Glance of Vietnam',
        tourImg:vietnam1,
        tourPrice: '41,100',
        days: '7',
        night: '0',
        pdfLink: ''
    },
    {
        countryName: 'Vietnam',
        tourName: 'Impressive Vietnam',
        tourImg:vietnam2,
        tourPrice: '37,900',
        days: '6',
        night: '5',
        pdfLink: ''
    },
    {
        countryName: 'Vietnam',
        tourName: 'Impressive Vietnam & Cambodia',
        tourImg:vietnam3,
        tourPrice: '75,600',
        days: '10',
        night: '9',
        pdfLink: ''
    },
    {
        countryName: 'Vietnam',
        tourName: 'Vietnam Visa-Single Entry',
        tourImg:vietnam4,
        tourPrice: '2,100',
        days: '0',
        night: '0',
        pdfLink: ''
    },
    {
        countryName: 'Vietnam',
        tourName: 'Hanoi and Halong Alisa Cruise',
        tourImg:vietnam5,
        tourPrice: '19,999',
        days: '5',
        night: '4',
        pdfLink: ''
    },
    {
        countryName: 'Vietnam',
        tourName: 'Vietnam with Hanoi, Ho Chi Minh and Halong Bay Cruise',
        tourImg:vietnam6,
        tourPrice: '47,999',
        days: '7',
        night: '6',
        pdfLink: ''
    },
    {
        countryName: 'Vietnam',
        tourName: 'Vietnam & Cambodia',
        tourImg:vietnam7,
        tourPrice: '70,999',
        days: '10',
        night: '9',
        pdfLink: ''
    },

    // Nepal
    {
        countryName: 'Nepal',
        tourName: 'Package for Kathmandu Pokhara Chitwan',
        tourImg:nepal1,
        tourPrice: '8,999',
        days: '6',
        night: '5',
        pdfLink: ''
    },
    {
        countryName: 'Nepal',
        tourName: 'Nepal with Kathmandu and Pokhara',
        tourImg:nepal2,
        tourPrice: '20,500',
        days: '7',
        night: '6',
        pdfLink: ''
    },
    {
        countryName: 'Nepal',
        tourName: 'Nepal - Dreamy Kathmandu',
        tourImg:nepal3,
        tourPrice: '11,999',
        days: '4',
        night: '3',
        pdfLink: ''
    },

    // CIS Countries

    // Iceland
    {
        countryName: 'Iceland',
        tourName: 'Iceland: Budget Friendly Aurora',
        tourImg:iceland1,
        tourPrice: '51,750',
        days: '5',
        night: '4',
        pdfLink: ''
    },
    {
        countryName: 'Iceland',
        tourName: 'Amazing Iceland',
        tourImg:iceland2,
        tourPrice: '1,54,000',
        days: '6',
        night: '5',
        pdfLink: ''
    },

    // Kenya
    {
        countryName: 'Kenya',
        tourName: 'Kenya, Naivasha-Maasai Mara',
        tourImg:kenya1,
        tourPrice: '71,760',
        days: '5',
        night: '4',
        pdfLink: ''
    },
    {
        countryName: 'Kenya',
        tourName: 'Kenya-Serena Safaris',
        tourImg:kenya2,
        tourPrice: '1,27,180',
        days: '8',
        night: '7',
        pdfLink: ''
    },

    // Azerbaijan
    {
        countryName: 'Azerbaijan',
        tourName: 'Arrival Transfer: Baku International Airport to City center Hotel (Private basis)',
        tourImg:azerbaijan1,
        tourPrice: '1,650',
        days: '0',
        night: '0',
        pdfLink: ''
    },
    {
        countryName: 'Azerbaijan',
        tourName: 'Azerbaijan E-Visa {Normal Process}',
        tourImg:azerbaijan2,
        tourPrice: '2,300',
        days: '0',
        night: '0',
        pdfLink: ''
    },
    {
        countryName: 'Azerbaijan',
        tourName: '4N Azerbaijan - Baku',
        tourImg:azerbaijan3,
        tourPrice: '17,400',
        days: '5',
        night: '4',
        pdfLink: ''
    },

    // UAE

    // China
    {
        countryName: 'China',
        tourName: 'China Single Entry Visa',
        tourImg:japan1,
        tourPrice: '7,500',
        days: '0',
        night: '0',
        pdfLink: ''
    },

    // Japan
    {
        countryName: 'Japan',
        tourName: 'Splendors of Japan',
        tourImg:japan2,
        tourPrice: '1,78,250',
        days: '8',
        night: '7',
        pdfLink: ''
    },
    {
        countryName: 'Japan',
        tourName: 'Japan sticker visa-Short stay',
        tourImg:japan3,
        tourPrice: '1,890',
        days: '0',
        night: '0',
        pdfLink: ''
    },

    // Canada
    {
        countryName: 'Canada',
        tourName: 'Elegant East Canada',
        tourImg:canada1,
        tourPrice: '1,08,000',
        days: '8',
        night: '7',
        pdfLink: ''
    },
    {
        countryName: 'Canada',
        tourName: 'Best Of Canada (Van Tour)',
        tourImg:canada2,
        tourPrice: '3,04,000',
        days: '13',
        night: '12',
        pdfLink: ''
    },
    {
        countryName: 'Canada',
        tourName: 'Elegant East Canada',
        tourImg:canada3,
        tourPrice: '1,08,000',
        days: '8',
        night: '7',
        pdfLink: ''
    },
    {
        countryName: 'Canada',
        tourName: 'Eastern Canada - Toronto to Montreal',
        tourImg:canada4,
        tourPrice: '83,950',
        days: '7',
        night: '6',
        pdfLink: ''
    },
    {
        countryName: 'Canada',
        tourName: 'Best Of Canada (Van Tour)',
        tourImg:canada5,
        tourPrice: '3,04,000',
        days: '13',
        night: '12',
        pdfLink: ''
    },
    {
        countryName: 'Canada',
        tourName: 'Best Of West Canada',
        tourImg:canada6,
        tourPrice: '1,25,000',
        days: '8',
        night: '7',
        pdfLink: ''
    },
    {
        countryName: 'Canada',
        tourName: 'Classique Canada',
        tourImg:canada7,
        tourPrice: '2,41,400',
        days: '15',
        night: '14',
        pdfLink: ''
    },

    // Israel
    {
        countryName: 'Israel',
        tourName: 'Holy Land Tour of Jordan , Israel, Palastine, And Egypt',
        tourImg: israel1,
        tourPrice: '1,09,000',
        days: '11',
        night: '10',
        pdfLink: ''
    },

    // USA
    {
        countryName: 'USA',
        tourName: 'Amazing USA',
        tourImg: usa1,
        tourPrice: '1,99,999',
        days: '12',
        night: '11',
        pdfLink: ''
    },
    {
        countryName: 'USA',
        tourName: 'Coast To Coast USA (Van Tour)',
        tourImg: usa2,
        tourPrice: '3,10,000',
        days: '13',
        night: '12',
        pdfLink: ''
    },
    {
        countryName: 'USA',
        tourName: 'Ultimate USA',
        tourImg: usa3,
        tourPrice: '2,59,999',
        days: '16',
        night: '15',
        pdfLink: ''
    },
    {
        countryName: 'USA',
        tourName: 'Amazing Texas',
        tourImg: usa4,
        tourPrice: '99,999',
        days: '7',
        night: '6',
        pdfLink: ''
    },
    {
        countryName: 'USA',
        tourName: 'Wonderful West Coast USA',
        tourImg: usa5,
        tourPrice: '1,05,000',
        days: '7',
        night: '6',
        pdfLink: ''
    },
    {
        countryName: 'USA',
        tourName: 'Exotic East Coast USA',
        tourImg: usa6,
        tourPrice: '1,55,000',
        days: '10',
        night: '9',
        pdfLink: ''
    },
    {
        countryName: 'USA',
        tourName: 'Aloha Hawaii',
        tourImg: usa7,
        tourPrice: '1,95,000',
        days: '12',
        night: '11',
        pdfLink: ''
    },

    // Russia
    {
        countryName: 'Russia',
        tourName: 'Russia - Moscow',
        tourImg:russia1,
        tourPrice: '68,999',
        days: '5',
        night: '4',
        pdfLink: ''
    },
    {
        countryName: 'Russia',
        tourName: 'Extravagance in Russia',
        tourImg:russia2,
        tourPrice: '99,999',
        days: '7',
        night: '6',
        pdfLink: ''
    },

    // Myanmar

    // Jordan
    {
        countryName: 'Jordan',
        tourName: 'Classical Tours of Jordan ',
        tourImg: jordan1,
        tourPrice: '67,850',
        days: '8',
        night: '7',
        pdfLink: ''
    },


    // Uzbekistan
    {
        countryName: 'Uzbekistan',
        tourName: 'TASHKENT (Uzbekistan)',
        tourImg: uzbekistan1,
        tourPrice: '44,300',
        days: '5',
        night: '4',
        pdfLink: ''
    },
    {
        countryName: 'Uzbekistan',
        tourName: 'Best of Uzbekistan',
        tourImg: uzbekistan2,
        tourPrice: '51,750',
        days: '0',
        night: '0',
        pdfLink: ''
    },






]